import { defineStore } from 'pinia';
import type { SearchFilters, LocationMultiValue } from '@/modules/content-blocks/interfaces/jobs-block.interface';
import type { City } from '@/core/components/form-elements/CitySelector.vue';

const createDefaultFilters = (): SearchFilters => ({
   quick_search: [],
   filter_elements: [
      { key: 'job_types', values: [] },
      { key: 'work_schedules', values: [] },
      { key: 'location_multi', values: [] },
   ],
});

export const useJobFiltersStore = defineStore('jobFilters', {
   state: () => ({
      filters: createDefaultFilters() as SearchFilters,
   }),

   getters: {
      searchQuery: (state): string => {
         return state.filters.quick_search[0]?.value || '';
      },

      jobTypes: (state): { value: number }[] => {
         const values = state.filters.filter_elements.find((f) => f.key === 'job_types')?.values ?? [];
         return values as { value: number }[];
      },

      workSchedules: (state): number[] => {
         const values = state.filters.filter_elements.find((f) => f.key === 'work_schedules')?.values ?? [];
         return values as number[];
      },

      cities: (state): number[] => {
         const values = state.filters.filter_elements.find((f) => f.key === 'location_multi')?.values ?? [];
         return values as number[];
      },

      searchCity: (state): City | null => {
         const values = state.filters.filter_elements.find((f) => f.key === 'location_multi')?.values ?? [];
         const locationValues = values as LocationMultiValue[];
         if (values.length === 0) return null;
         return { id: locationValues[0].city_id, name: '' };
      },
   },

   actions: {
      setSearchQuery(value: string) {
         this.filters.quick_search = value ? [{ value }] : [];
      },

      setJobTypes(values: { value: number }[]) {
         const jobTypesFilter = this.filters.filter_elements.find((f) => f.key === 'job_types');
         if (jobTypesFilter) {
            jobTypesFilter.values = values;
         }
      },

      setWorkSchedules(values: number[]) {
         const workSchedulesFilter = this.filters.filter_elements.find((f) => f.key === 'work_schedules');
         if (workSchedulesFilter) {
            workSchedulesFilter.values = values;
         }
      },

      setCities(values: number[]) {
         const citiesFilter = this.filters.filter_elements.find((f) => f.key === 'location_multi');
         if (citiesFilter) {
            citiesFilter.values = values;
         }
      },

      setSearchCity(city: City | null) {
         const locationFilter = this.filters.filter_elements.find((f) => f.key === 'location_multi');
         if (locationFilter) {
            locationFilter.values = city ? [{ city_id: city.id, radius: 10 }] : [];
         }
      },
   },
});
